<template>
    <div class="app-tab-bar">
            <van-popup v-model="weixinImgshow" closeable :style="{width: '60%',backgroundColor: 'unset'}" round>
                <van-image :src=UPLOAD_FILE_PATH+rent.rentWechatUrl></van-image>
            </van-popup>
            <!-- 悬浮图标 -->
            <FloatButton :bottomX=weixinBottomX :handleClick=weixinClick :imgsrc=weixinIcon></FloatButton>
            <FloatButton :bottomX=dianhuaBottomX :handleClick=dianhuaClick :imgsrc=dianhuaIcon></FloatButton>
        <!-- <FloatButton :bottom='10'/> -->
        <!-- 下方导航 -->
        <van-tabbar
            v-model="active"
            active-color="#ee0a24"
            inactive-color="#000"
            @change="onChange"
            shape="round"
            route>
            <van-tabbar-item v-for="item in menuList" :key="item.mentId" :icon="item.menuIcon" :to="item.menuTo+'/'+rent.rentPath">{{item.menuName}}</van-tabbar-item>
        </van-tabbar>

    </div>
</template>

<script>
import FloatButton from './FloatButton.vue'
import weixin from '../icon/weixin.png'
import dianhua from '../icon/dianhua.png'
import { getmenuList, UPLOAD_FILE_PATH} from "@/https/http.js";

export default {
    name: "app-tab-bar",
    data () {
        return {
            UPLOAD_FILE_PATH:UPLOAD_FILE_PATH,
            weixinBottomX: '2rem',
            weixinIcon:weixin,
            weixinImgshow:false,

            dianhuaBottomX: '3.5rem',
            dianhuaIcon:dianhua,

            rent:{},


            active:0,
            menuList:[]
        }
    },
    components: {
        FloatButton
    },
    created(){
        this.rent = JSON.parse(localStorage.getItem("rent"))
        this.menuList = JSON.parse(localStorage.getItem("menuList"))
    },
    methods: {
        onChange(m) {
            this.active = m
        },
        dianhuaClick(){
            window.location.href = 'tel://' + this.rent.rentTel
        },
        weixinClick(){
            this.weixinImgshow=true
        }
    },
};
</script>

<style></style>
